/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

import Calendar from './calendar/cs_CZ';
import DatePicker from './date-picker/cs_CZ';
import Pagination from './pagination/cs_CZ';
import TimePicker from './time-picker/cs_CZ';

export default {
  locale: 'cs',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Filtr',
    filterConfirm: 'Potvrdit',
    filterReset: 'Obnovit'
  },
  Modal: {
    okText: 'Ok',
    cancelText: 'Storno',
    justOkText: 'Ok'
  },
  Popconfirm: {
    okText: 'Ok',
    cancelText: 'Storno'
  },
  Transfer: {
    searchPlaceholder: 'VyhledÃ¡vÃ¡nÃ­',
    itemUnit: 'poloÅ¾ka',
    itemsUnit: 'poloÅ¾ek'
  },
  Upload: {
    uploading: 'NahrÃ¡vÃ¡nÃ­...',
    removeFile: 'Odstranit soubor',
    uploadError: 'Chyba pÅi nahrÃ¡vÃ¡nÃ­',
    previewFile: 'Zobrazit soubor'
  },
  Empty: {
    description: 'Å½Ã¡dnÃ¡ data'
  }
};
